import * as React from 'react';

import { useMutation } from '@apollo/client';

import Button, { ButtonTypes } from 'common/components/core/Button/Button';
import { LogoutMutation } from 'common/graphql/mutations/authentication';

import { clearTokenAndNavigate, clearTokenAndReload } from '../../helpers/authenticationHelper';

export type LogoutButtonProps = {
  ['data-test']?: string;
  text?: string;
  className?: string;
  fullWidth?: boolean;
  type?: ButtonTypes;
  customLogoutUrl?: string;
};

/**
 * LogoutButton component
 *
 * Displays a button that handles logging the user out.
 */
export default function LogoutButton(props: LogoutButtonProps) {
  const { text = 'Log Out', className, customLogoutUrl, type, fullWidth } = props;

  const [logoutMutation] = useMutation(LogoutMutation);

  const handleClick = async () => {
    // Fire-and-forget the logout mutation.
    try {
      await logoutMutation();
    } finally {
      if (customLogoutUrl) {
        clearTokenAndNavigate(customLogoutUrl);
      } else {
        clearTokenAndReload();
      }
    }
  };

  return (
    <Button
      className={className}
      label={text}
      fullWidth={fullWidth}
      data-test={props['data-test']}
      onClick={handleClick}
      type={type ?? ButtonTypes.NAVIGATION_SECONDARY}
    >
      {text}
    </Button>
  );
}
